import React, { useState } from "react";
import { useSelector } from "react-redux";
import CustomInput from "../../Core/Components/CustomInput";
import CloseIcon from "../../Common/Svgs/CloseIcon";
import FilterItem from "../../Core/Components/FilterItem";
import { LOCATION_TYPE } from "../Location/Data";
import { statusFilters } from "./getStatus";

const Header = ({
  search,
  setSearch,
  filters,
  setFilters,
  setCurrentPage,
  setRentalFeeModal,
}) => {
  const { allLocations } = useSelector((state) => state.locations);

  // get all the hubs
  const hubFilters = allLocations
    .filter((item) => item.type === LOCATION_TYPE.HUB_STATION)
    .map((location) => ({
      id: location.id,
      value: location.name,
    }));

  const [focus, setFocus] = useState(false);

  const onSelect = (key, value) => {
    // whenever applying the filter, the page should be defaulted back to first page
    setCurrentPage(1);

    if (filters[key].includes(value)) {
      const newFilters = filters[key].filter((item) => item !== value);
      setFilters({ ...filters, [key]: newFilters });
    } else {
      setFilters({ ...filters, [key]: [...filters[key], value] });
    }
  };

  return (
    <div className="bg-background-white">
      <div className="px-6 py-3.5 flex items-center justify-between">
        <div className="flex items-center gap-x-3">
          <CustomInput
            intent="search"
            prefix={
              <img src="/assets/icons/search.svg" alt="" className="mr-2" />
            }
            value={search}
            focus={focus}
            border={focus ? "success" : "none"}
            placeholder={focus ? null : "Search Vehicle ID, Driver"}
            onChange={(e) => setSearch(e.target.value)}
            onFocus={() => setFocus(true)}
            onBlur={() => setFocus(false)}
            suffix={
              search.length > 0 ? (
                <CloseIcon
                  className="w-4 h-4 cursor-pointer stroke-dark-grey-text"
                  onClick={() => {
                    setFocus(false);
                    setSearch("");
                  }}
                />
              ) : null
            }
          />

          <FilterItem
            label="Hub Station"
            identifier="hubs"
            contentData={hubFilters}
            onSelect={onSelect}
            selectedValues={filters.hubs}
            className="max-h-[200px] overflow-y-scroll"
            enableSearch
          />

          <FilterItem
            label="Status"
            identifier="status"
            customValue
            className="max-h-max"
            contentData={statusFilters()}
            onSelect={onSelect}
            selectedValues={filters.status}
          />
        </div>

        <button
          type="button"
          className="flex items-center justify-center w-[118px] h-11 bg-primary hover:bg-primary-50 rounded-md"
          onClick={() => setRentalFeeModal(true)}
        >
          <p className="font-poppins text-xs font-medium text-background-white">
            Set Rental Fee
          </p>
        </button>
      </div>
    </div>
  );
};

export default Header;
